import { Skeleton, Stack } from '@eluve/components';

export interface TableSkeletonProps {
  rowCount?: number;
  columnCount?: number;
}

export function TableSkeleton({
  columnCount = 5,
  rowCount = 8,
}: TableSkeletonProps) {
  return (
    <Stack gap={2}>
      {Array.from({ length: rowCount }, (_, rowIndex) => (
        <Stack key={rowIndex} direction="horizontal" gap={2}>
          {Array.from({ length: columnCount }, (_, colIndex) => (
            <Skeleton key={colIndex} className="h-6 w-full flex-1" />
          ))}
        </Stack>
      ))}
    </Stack>
  );
}
